import React from "react";
import { Navigate, Outlet } from "react-router-dom";

// Временный флаг: если true — на внутренние страницы пускаем
// только при наличии JWT-токена в localStorage.
//
// Выключать его больше незачем: вход по логину работает, SmartCaptcha стоит
// только на регистрации и восстановлении пароля, форму логина она не трогает.
// С выключенным флагом страница открывалась без токена, но API его требует —
// раздел документов встречал пользователя ошибкой «Вы не авторизованы».
const REQUIRE_JWT_TOKEN = true;

const PrivateRoute = () => {
  if (!REQUIRE_JWT_TOKEN) {
    // Проверки отключены — всегда пускаем внутрь.
    return <Outlet />;
  }

  const token = localStorage.getItem("token");

  // Если токен есть — считаем, что пользователь авторизован.
  if (token) {
    return <Outlet />;
  }

  // Токена нет — отправляем на страницу логина.
  return <Navigate exact to={`${process.env.PUBLIC_URL}/login`} />;
};

export default PrivateRoute;
